import styled from "styled-components";
import { providerSettingsContainerStyle } from "theme/provider-container";

export const PageWrapper = styled.div`
  ${providerSettingsContainerStyle}
`;

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  max-width: 66rem;
  margin: 0 auto;
`;

export const FiltersDropDownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  max-width: 66rem;
  width: 100%;
  padding: 1rem;

  ${({ theme }) => theme.mq.md`
    display: flex;
    padding: 1.5rem 1rem 1.5rem;
  `}
`;

export const FilterWrapper = styled.div`
  display: none;
  font-size: ${({ theme }) => theme.fontSize(4)};
  padding: 0;
  width: 100%;

  ${({ theme }) => theme.mq.md`
    display: flex;
    width: 100%;
    max-width: ${theme.settings.sizes.maxContentWidth}px;
  `}
`;

export const FilterPill = styled.button`
  background-color: transparent;
  border: 0.0625rem solid
    ${({ theme, select }) =>
      select ? theme.themeColors.orange1 : theme.themeColors.darkGreen4};
  border-radius: 1.3125rem;
  color: ${({ theme, select }) =>
    select ? theme.themeColors.orange1 : theme.themeColors.darkGreen4};
  font-size: ${({ theme }) => theme.fontSize(1)};
  font-weight: 400;
  min-width: 3.5rem;
  padding: 0.4rem 1rem 0.2rem 1rem;
  margin: 0 0 0 0.375rem;
  white-space: nowrap;

  :focus {
    outline: 0;
  }

  :focus-visible {
    outline: 0.125rem solid #0070f3;
  }
  :first-of-type {
    margin-left: 0;
  }
`;

export const DropDownWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${({ theme }) => theme.mq.md`
    justify-content: flex-end;
    margin-top: 0;
  `}
`;

export const PillWrapper = styled.div`
  ${({ theme }) => theme.mq.md`
    display: inline-block;
  `}
`;

export const FilterPillWrapper = styled.div`
  padding: 0;
  align-self: center;

  ${({ theme }) => theme.mq.md`
    display: none;
  `}
`;

export const ApptPillWrapper = styled(FilterPillWrapper)`
  ${({ theme }) => theme.mq.md`
    display: inline-block;
  `}
`;

export const EmptyApptWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 5rem;
`;

export const IconWrapper = styled.div`
  margin-bottom: 1rem;

  ${({ theme }) => theme.mq.lg`
    margin-bottom: 2rem;
  `}
`;
export const EmptyApptTitle = styled.h3`
  font-size: ${({ theme }) => theme.fontSize(4)};
  margin-bottom: 1rem;
  text-align: center;
`;

export const EmptyApptSub = styled.div`
  font-size: ${({ theme }) => theme.fontSize(2)};
  font-weight: 400;
  text-align: center;
`;

export const AppointmentWrapper = styled.div`
  width: 100%;
  margin: 0 0 1rem;
`;

export const CardWrapper = styled.button`
  background: transparent;
  border: 0 transparent;

  :focus {
    outline: 0;
  }

  :focus-visible {
    outline: 2px solid #0070f3;
  }
`;

export const ListWrapper = styled.div`
  ${providerSettingsContainerStyle}
  padding-top: 0;
`;

export const LineBreak = styled.hr`
  width: 100%;
  border: none;
  border-top: 0.0625rem solid ${({ theme }) => theme.themeColors.lightGrey};
  margin: 0 0 2rem 0;
`;

export const ProfileHeadText = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: auto;
  opacity: 0.5;
  font-size: ${({ theme }) => theme.fontSize(1)};
  line-height: 1.125rem;
  color: #27272f;
  font-weight: 400;
`;

export const ImgContainer = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto 0;
  border-radius: 100%;
  height: 2.875rem;
  width: 2.875rem;
  min-width: 2.875rem;
  min-height: 2.875rem;
  text-align: center;
  line-height: 1;
`;

export const ProfileIcon = styled.div`
  background-color: ${({ color }) => color || "#f6ab2b"};
  margin: auto 0;
  border-radius: 100%;
  height: 2.875rem;
  width: 2.875rem;
  min-width: 2.875rem;
  min-height: 2.875rem;
  text-align: center;
  padding: 0.625rem;
  color: ${({ theme }) => theme.themeColors.white};
  border: 0.125rem solid transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color 0.2s;
`;

export const CenterDiv = styled.div`
  text-align: center;
`;

export const LinkWrapper = styled.a`
  display: flex;
  margin: 0 auto;
  max-width: 375px;
  width: 100%;

  ${({ theme }) => theme.mq.sm`
    margin: 0 auto 45px auto;
    max-width: 201px;
  `}

  ${({ theme }) => theme.mq.lg`
    margin: 0;
  `}
`;
